import AppIntroSlider from "react-native-app-intro-slider";
import I18n from "i18n-js";
import React from "react";

import { StyleSheet, View, Dimensions } from "react-native";
import { connect } from "react-redux";

import IntroSlide from "../components/IntroSlide";

import fonts from "../constants/fonts";

const { width } = Dimensions.get("window");

class IntroScreen extends React.Component {
  handleDone() {
    this.props.navigation.goBack();
  }

  handleSkip() {
    this.props.navigation.goBack();
  }

  renderItem({ item }) {
    return (
      <IntroSlide content={item.text} image={item.image} title={item.title} width={width} />
    );
  }

  render() {
    const { introSlides, themeColors } = this.props;

    return (
      <View
        style={[
          styles.container,
          {
            backgroundColor: themeColors.lightestPrimary
          }
        ]}
      >
        <AppIntroSlider
          activeDotStyle={{
            backgroundColor: themeColors.darkestPrimary
          }}
          buttonTextStyle={[
            styles.buttonText,
            {
              color: themeColors.darkestPrimary
            }
          ]}
          doneLabel={I18n.t("prixa.done")}
          dotStyle={{ backgroundColor: themeColors.lighterPrimary }}
          nextLabel={I18n.t("prixa.next")}
          onDone={() => this.handleDone()}
          onSkip={() => this.handleSkip()}
          prevLabel={I18n.t("prixa.previous")}
          renderItem={this.renderItem}
          showPrevButton={true}
          showSkipButton={true}
          skipLabel={I18n.t("prixa.skip")}
          slides={introSlides}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  buttonText: {
    fontSize: 16,

    ...fonts.bold
  },
  container: {
    flex: 1
  }
});

export default connect(state => ({
  introSlides: state.introSlides,
  themeColors: state.themeColors
}))(IntroScreen);
